const r = "_textarea_1r5s5_1", t = "_error_1r5s5_45", e = "_container_1r5s5_49", a = {
  textarea: r,
  error: t,
  container: e
};
export {
  e as container,
  a as default,
  t as error,
  r as textarea
};
//# sourceMappingURL=Textarea.module.css.js.map
